import { areaIcons } from './areaIcons';
import { FEATURE_FLAGS } from './featureFlags';
import type { MenuItem } from '@/components/global/Sidebar/components/MenuListItem/types';

export const menuItems: MenuItem[] = [
  {
    path: null,
    id: 'Register',
    label: 'RegisterParent',
    icon: areaIcons.register,
    requiredPagePermission: null,
    additionallyHighlightingPaths: ['/Registration/', '/register/'],
    items: [
      {
        path: '/Registration/TimeTracking',
        id: 'TimeTrackingBase',
        label: 'TimeTrackingBase',
        requiredPagePermission: 'TimeTrackingBase',
      },
      {
        path: '/Registration/Timesheet/TravelExpense',
        id: 'TravelExpenses',
        label: 'TravelExpenses',
        requiredPagePermission: 'TravelExpenses',
      },
      {
        path: '/Registration/Expenses/ExpensesBatch',
        id: 'ExpensesBatch',
        label: 'ExpensesBatch',
        requiredPagePermission: 'ExpensesBatch',
      },
      {
        path: '/Reports/Personal/ExpenseReportSubmitPrint',
        id: 'ExpenseReportSubmitPrint',
        label: 'ExpenseReportSubmitPrint',
        requiredPagePermission: 'ExpenseReportSubmitPrint',
        highlightMustBeExactMatch: true,
      },
      {
        path: '/Registration/Timesheet/TrackerInstall',
        id: 'TimeLogTrackerInstall',
        label: 'TimeLogTrackerInstall',
        requiredPagePermission: null,
      },
    ],
  },
  {
    path: '/Reports/Report/BoxView',
    id: 'Reports',
    label: 'Reports',
    icon: areaIcons.reports,
    requiredPagePermission: null,
    hiddenOnFeatureFlag: FEATURE_FLAGS.DASHBOARDS_REPORTING, // Old reports item gets hidden, as it will be replaced by the new "Reporting" parent menu item
  },
  {
    path: null,
    id: 'Reports',
    label: 'Reporting',
    icon: areaIcons.reports,
    requiredPagePermission: null,
    requiredFeatureFlag: FEATURE_FLAGS.DASHBOARDS_REPORTING,
    items: [
      {
        path: '/reporting',
        id: 'Dashboards',
        label: 'Dashboards',
        requiredPagePermission: 'DashboardsOverview',
      },
      {
        path: '/Reports/Report/BoxView',
        id: 'Reports',
        label: 'Reports',
        requiredPagePermission: null,
      },
    ],
  },
  {
    path: null,
    id: 'Projects',
    label: 'ProjectsParent',
    icon: areaIcons.projects,
    requiredPagePermission: null,
    additionallyHighlightingPaths: ['/ProjectManagement/', '/projects/'],
    items: [
      {
        path: '/projects',
        id: 'ProjectPortfolioOverview',
        label: 'ProjectPortfolio',
        // We handle permission to Portfolio page via a specific page permission 'DesignSevenSearchProject'
        requiredPagePermission: 'DesignSevenSearchProject',
        requiredFeatureFlag: FEATURE_FLAGS.PROJECT_PORTFOLIO,
        highlightMustBeExactMatch: true,
        status: 'new',
      },
      {
        path: '/projects/search-projects',
        id: 'DesignSevenSearchProject',
        label: 'DesignSevenSearchProject',
        requiredPagePermission: 'DesignSevenSearchProject',
      },
      {
        path: '/projects/resource-planner',
        id: 'ProjectsResourcePlanner',
        label: 'ResourcePlanner',
        requiredPagePermission: 'NewResourcePlanner',
      },
      {
        path: '/projects/move-hours',
        id: 'DesignSevenMoveHours',
        label: 'DesignSevenMoveHours',
        requiredPagePermission: 'DesignSevenMoveHours',
      },
      {
        path: '/ProjectManagement/Adjustment/ChangeHourlyRatesOnAllocations',
        id: 'ChangeHourlyRatesOnAllocations',
        label: 'ChangeHourlyRatesOnAllocations',
        requiredPagePermission: 'ChangeHourlyRatesOnAllocations',
      },
      {
        path: '/ProjectManagement/Adjustment/MoveAllocations',
        id: 'MoveAllocations',
        label: 'MoveAllocations',
        requiredPagePermission: 'MoveAllocations',
      },
      {
        path: '/ProjectManagement/Adjustment/AdjustProjectPayments',
        id: 'AdjustProjectPayments',
        label: 'AdjustProjectPayments',
        requiredPagePermission: 'AdjustProjectPayments',
      },
      {
        path: '/ProjectManagement/IndexationOfHourlyRate',
        id: 'IndexationOfHourlyRateBase',
        label: 'IndexationOfHourlyRateBase',
        requiredPagePermission: 'IndexationOfHourlyRateBase',
      },
      {
        path: '/ProjectManagement/IndexationRecurringContractsAndProducts',
        id: 'IndexationRecurringContractsAndProducts',
        label: 'IndexationRecurringContractsAndProducts',
        requiredPagePermission: 'IndexationRecurringContractsAndProducts',
      },
    ],
  },
  {
    path: null,
    id: 'Employees',
    label: 'EmployeesParent',
    icon: areaIcons.employees,
    requiredPagePermission: null,
    additionallyHighlightingPaths: [
      '/Employee/',
      '/Organization/Employee/EditEmployee',
      '/Organization/Employee/NewEmployee',
    ],
    items: [
      {
        path: '/employees',
        id: 'EmployeePortfolioOverview',
        label: 'EmployeeOverviewBase',
        requiredPagePermission: 'EmployeePortfolioOverview',
        requiredFeatureFlag: FEATURE_FLAGS.EMPLOYEE_PORTFOLIO,
        highlightMustBeExactMatch: true,
        status: 'beta',
      },
      {
        path: '/Employee/EmployeeOverview',
        id: 'EmployeeOverviewBase',
        label: 'EmployeeOverviewBase',
        requiredPagePermission: 'EmployeeOverviewBase',
        hiddenOnFeatureFlag: FEATURE_FLAGS.EMPLOYEE_PORTFOLIO,
      },
      {
        path: '/Organization/Employee/ApproveProjectTimeReports',
        id: 'ApproveProjectTimeReports',
        label: 'ApproveProjectTimeReports',
        requiredPagePermission: 'ApproveProjectTimeReports',
      },
      {
        path: '/Employee/Approval',
        id: 'ApproveTimeReports',
        label: 'ApproveTimeReports',
        requiredPagePermission: 'ApproveTimeReports',
      },
      {
        path: '/Organization/Employee/ApproveExpenses',
        id: 'ApproveExpenses',
        label: 'ApproveExpenses',
        requiredPagePermission: 'ApproveExpenses',
      },
      {
        path: '/Organization/Employee/ResourcePlanner',
        id: 'EmployeesResourcePlanner',
        label: 'ResourcePlanner',
        requiredPagePermission: 'ResourcePlanner',
      },
      {
        path: '/Organization/AdvancedResourcePlanner',
        id: 'AdvancedResourcePlanner',
        label: 'AdvancedResourcePlanner',
        requiredPagePermission: 'AdvancedResourcePlanner',
      },
      {
        path: '/Integration/SalaryExport',
        id: 'TransferEmployeeSalary',
        label: 'TransferEmployeeSalary',
        requiredPagePermission: 'TransferEmployeeSalary',
        highlightMustBeExactMatch: true,
      },
      {
        path: '/Integration/SalaryExport/SalaryPeriods',
        id: 'SalaryPeriods',
        label: 'SalaryPeriods',
        requiredPagePermission: 'SalaryPeriods',
      },
      {
        path: '/Employee/Salary/SalaryManagementOverview',
        id: 'SalaryManagementOverview',
        label: 'SalaryManagementOverview',
        requiredPagePermission: 'SalaryManagementOverview',
      },
      {
        path: '/Integration/TransferExpense',
        id: 'TransferEmployeeExpense',
        label: 'TransferEmployeeExpense',
        requiredPagePermission: 'TransferEmployeeExpense',
      },
    ],
  },
  {
    path: null,
    id: 'Invoices',
    label: 'InvoicesParent',
    icon: areaIcons.invoices,
    requiredPagePermission: null,
    additionallyHighlightingPaths: ['/Financial/Invoicing/'],
    items: [
      {
        path: '/Financial/Invoicing/SearchInvoice',
        id: 'SearchInvoice',
        label: 'SearchInvoice',
        requiredPagePermission: 'SearchInvoice',
        highlightMustBeExactMatch: true,
      },
      {
        path: '/Financial/Invoicing/SearchInvoiceArchive',
        id: 'InvoiceArchive',
        label: 'InvoiceArchive',
        requiredPagePermission: 'InvoiceArchive',
      },
      {
        path: '/Financial/Invoicing/DebtorListInvoice',
        id: 'DebtorListInvoices',
        label: 'DebtorListInvoices',
        requiredPagePermission: 'NewDebtorListInvoice',
      },
      {
        path: '/Financial/Invoicing/DebtorListVoucher',
        id: 'DebtorListVouchers',
        label: 'DebtorListVouchers',
        requiredPagePermission: 'NewDebtorListVoucher',
      },
      {
        path: '/Financial/Invoicing/TransferInvoices',
        id: 'TransferInvoices',
        label: 'TransferInvoices',
        requiredPagePermission: 'TransferInvoices',
      },
      {
        path: '/Financial/AccountingPeriod/InvoiceAccountingPeriod',
        id: 'InvoiceAccountingPeriod',
        label: 'InvoiceAccountingPeriod',
        requiredPagePermission: 'InvoiceAccountingPeriod',
      },
      {
        path: '/Financial/IntercompanyInvoice',
        id: 'IntercompanyInvoice',
        label: 'IntercompanyInvoice',
        requiredPagePermission: 'IntercompanyInvoice',
      },
    ],
  },
  {
    path: null,
    id: 'Customers',
    label: 'CustomersParent',
    icon: areaIcons.customers,
    requiredPagePermission: null,
    additionallyHighlightingPaths: ['/CRM/Journal', '/CRM/Opportunity'],
    items: [
      {
        path: '/CRM/Home',
        id: 'CRMHomeStart',
        label: 'CRMHomeStart',
        requiredPagePermission: 'CRMHomeStart',
      },
      {
        path: '/CRM/Customer',
        id: 'CRMCustomer',
        label: 'CRMCustomer',
        requiredPagePermission: 'CRMCustomer',
      },
      {
        path: '/CRM/Contact',
        id: 'CRMContact',
        label: 'CRMContact',
        requiredPagePermission: 'CRMContact',
      },
      {
        path: '/CRM/Event',
        id: 'CRMEvent',
        label: 'CRMEvent',
        requiredPagePermission: 'CRMEvent',
      },
      {
        path: '/CRM/Pipeline',
        id: 'CRMPipeline',
        label: 'CRMPipeline',
        requiredPagePermission: 'CRMPipeline',
      },
    ],
  },
] satisfies MenuItem[];

export type MenuItemId = (typeof menuItems)[number]['id'];

export const homeMenuPathRoute = '/home';

export const profileMenuItem = {
  base: '/Settings/UserSettings',
  start: '/Settings/UserSettings/PersonalSettings',
  icon: areaIcons.personalSettings,
  id: 'ProfileMenu',
};

export const pageSettingsMenuItem: MenuItem = {
  path: null,
  id: 'SettingsPage',
  label: 'SettingsPage',
  icon: areaIcons.pageSettings,
  requiredPagePermission: null,
};

export const settingsMenuItem: MenuItem = {
  path: '/Settings/General/RootPage',
  id: 'SettingsSystem',
  label: 'SettingsSystem',
  icon: areaIcons.systemSettings,
  requiredPagePermission: null,
};
export const accountSettingsMenuItem: MenuItem = {
  path: null,
  id: 'AccountPortal',
  label: 'AccountPortal',
  icon: areaIcons.accountSettings,
  requiredPagePermission: null,
};

export const logoutMenuItem: MenuItem = {
  path: '/logout',
  id: 'ProfileLogout',
  label: 'ProfileLogout',
  icon: areaIcons.logout,
  requiredPagePermission: null,
};
